import { gql } from "@apollo/client";

export const BINANCE_FUTTURES = gql`
    mutation BinanceFutures($timestamp: DateTime!,  $totalMarginBalance: Float!) {
        createBinanceFuture( data: {timestamp: $timestamp,  totalMarginBalance: $totalMarginBalance }){
            id,
            timestamp,
            totalMarginBalance,
        }
        publishBinanceFuture(where: {timestamp: $timestamp}) {
            id
        }
    }
`;

export const GET_FUTUTERS_TOTAL_MARGIN = gql`
    query BinanceFutures {
        binanceFutures(first: 1) {
            totalMarginBalance,
            timestamp,
        }
    }
`